import type { AiBusinessCenterModule } from '../types'

export const erpModule: AiBusinessCenterModule = {
  key: 'erp',
  label: 'ERP进销存',
  desc: '采购管理 / 销售管理 / 库存管理 / 财务管理',
  path: '/erp',
  homePath: '/erp/dashboard',
  icon: 'ep:goods',
  color: '#f59e0b',
  aliases: ['ERP 进销存', 'ERP系统', 'ERP', '进销存']
}
